export default class MainMenu {

    constructor(menuToggle = '.site-header .menu-toggle') {
        this.rootHtml = document.querySelector('html');

        // Setup menu
        this.menuToggle = document.querySelector(menuToggle);
        this.menu = document.querySelector(this.menuToggle.hash);
        this.menuItems = this.menu.querySelectorAll('.menu-item-has-children > a');

        // Init events only on mobile
        const styles = window.getComputedStyle(this.menuToggle);
        if(styles.display !== 'none') {
            this.addEvents();
        }

        this.watchScroll();
        window.addEventListener('scroll', () => this.watchScroll());
    }

    addEvents ()
    {
        // Toggle menu
        this.menuToggle.addEventListener('click', (e) => this.show(e));

        // SubMenus
        this.menuItems.forEach(el => {
            el.classList.add('is-closed'); // Close all at first
            el.addEventListener('click', (event) => {
                event.preventDefault();
                this.subMenuClick(event, el);
            });
        }, this);
    }

    // Toggle a submenu onClick
    subMenuClick (event, el) {
        // Close all items but toggle the one that was clicked
        this.menuItems.forEach(sub => {
            if(sub === el) {
                sub.classList.toggle('is-closed');
            } else {
                sub.classList.add('is-closed');
            }
        });
    }

    // Show-hide the menu
    show (event)
    {
        event.preventDefault();
        this.rootHtml.classList.toggle('menu-on');
    }

    // Function executed on scroll
    watchScroll() {
        if (window.scrollY >= 500) {
            this.rootHtml.classList.add('has-scrolled');
        } else {
            this.rootHtml.classList.remove('has-scrolled');
        }
    }
}
